import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule, MiscModule } from 'projects/core/src/public-api';
import { PunchWidgetDialogComponent } from './view/punch-widget-dialog/punch-widget-dialog.component';
import { DayTotalComponent } from './view/punch-widget-dialog/day-total/day-total.component';
import { WeekTotalComponent } from './view/punch-widget-dialog/week-total/week-total.component';
import { PayPeriodComponent } from './view/punch-widget-dialog/pay-period/pay-period.component';
import { TimesheetComponent } from './view/punch-widget-dialog/timesheet/timesheet.component';
import { BreakComponent } from './view/punch-widget-dialog/break/break.component';
import { AccordionModule } from 'primeng/accordion';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { StandaloneChartComponent } from './view/punch-widget-dialog/standalone-chart/standalone-chart.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatRippleModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { ChooseProjecComponent } from './view/punch-widget-dialog/choose-project/choose-project.component';
import { VacationPeriodComponent } from './view/punch-widget-dialog/vacation-period/vacation-period.component';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
	declarations: [
		PunchWidgetDialogComponent,
		DayTotalComponent,
		WeekTotalComponent,
		PayPeriodComponent,
		TimesheetComponent,
		BreakComponent,
		StandaloneChartComponent,
		ChooseProjecComponent,
		VacationPeriodComponent
	],
	imports: [
		CommonModule,
		MatIconModule,
		MatButtonModule,
		MatDialogModule,
		MatProgressSpinnerModule,
		MatButtonModule,
		MatTabsModule,
		MatSnackBarModule,
		AccordionModule,
		OverlayPanelModule,
		MatRippleModule,
		MiscModule,
    TooltipModule,
		CoreModule
	],
	exports: [
		BreakComponent,
		ChooseProjecComponent
	],
	entryComponents: [PunchWidgetDialogComponent]

})
export class PunchWidgetModule { }
